import ScrollPage from "@/components/ScrollPage";
import TwoFactorAuth from "./TwoFactorAuth";

export default function UsersPage() {

    return (
        <ScrollPage>
            <div className="grid grid-cols-1 gap-3">
                <TwoFactorAuth />
            </div>
        </ScrollPage>
    )
}